import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { Box, Flex, Text, TextInput, Group, Pagination } from '@mantine/core'
import { getListUsers } from '../../../../services/users'
import { useDebouncedCallback } from '@mantine/hooks'
import { useNavigate } from 'react-router-dom'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import TableRoleUserList from '../../../../component/pages/Users/TableRoleUserList'

const defaultParameter = {
  'filter[is_partner][is]': 1,
  'sort': '-created_at',
  'page[num]': 1,
  'page[limit]': 10,
  'fields[user]': 'name,email,phone,balance,commision_orders',
  'filter[name][like]': ''
}

const labelTable = [
  {
    label: 'ID',
    width: 30
  },
  {
    label: 'Name',
    width: 200
  },
  {
    label: 'Email',
    width: 150
  },
  {
    label: 'Phone',
    width: 150
  },
  {
    label: 'Agent Order',
    width: 100
  },
  {
    label: 'Credit Balance',
    width: 200
  },
  {
    label: 'Action',
    width: 50
  },
]

const PartnerList = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [params, setParams] = useState(defaultParameter)
  const [partnerUserList, setPartnerUserList] = useState([])
  const [totalUser, setTotalUser] = useState(0)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'users',
      route: null
    },
    {
      label: 'partners',
      route: null
    },
  ]

  const handleGetListPartners = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getListUsers(params)
      if (response.data.success) {
        const { data, meta } = response.data

        const countData = meta.pagination.total || 0

        const remapData = data.map((val) => {
          return {
            ...val.attributes
          }
        })

        setPartnerUserList(remapData)
        setTotalUser(countData)
      } else {
        setPartnerUserList([])
        setTotalUser(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, 300)

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetListPartners()
    // eslint-disable-next-line
  }, [params])

  const actions = {
    balance: (val) => {
      navigate(`/users/${val.id}?tab=balanceHistory`)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const handleFilter = (name, val) => {
    setParams((oldVal) => ({ ...oldVal, [name]: val }))
    handleChangePage(1)
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Partners User</Text>
            <TextInput
              placeholder='Search by name. . .'
              name="name"
              onChange={(val) => handleFilter('filter[name][like]', val.target.value)}
              size='xs'
            />
          </Flex>

          <Group my={10} gap='xs'>
            <Text fz={12}>Total Data Found: </Text>
            <Text fz={12} fw='bold'>{loading ? 0 : totalUser} Users </Text>
          </Group>

          <Box my={30}>
            {loading ? <LoadingData /> : partnerUserList.length > 0 ? <TableRoleUserList label={labelTable} data={partnerUserList} actionMethod={handleAction} /> : <NoData />}
          </Box>

        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} total={Math.ceil(totalUser / params['page[limit]']) || 0} />
        </Flex>
        </Box>
      </Box>
    </AuthLayout>
  )
}

export default PartnerList